import { Box, type BoxProps, useTheme } from '@mui/material';

import BillxLogoDark from '/billx-dark.svg';
import BillxLogoLight from '/billx-light.svg';

export interface LogoProps extends BoxProps {
  height: string | number;
  width: string | number;
}

export const Logo: React.FC<LogoProps> = ({ height, width, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      component="img"
      src={theme.palette.mode === 'dark' ? BillxLogoLight : BillxLogoDark}
      alt="Billx Logo"
      {...props}
      sx={{ height, width }}
    />
  );
};
